import { SvgCommonProperties } from '../../common/svg.interfaces';

export default function HamburgerSvg(props: SvgCommonProperties){
  return <svg
    height={props.height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="w-6 h-6"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9 9h6" />
    <path d="M10 14h4" />
  </svg>
}